import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Cookies from 'js-cookie';
import { API_BASE_URL } from "../config";

function LoginAdminGeral() {
  const [celular, setCelular] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErro("");

    try {
      const response = await axios.post(`${API_BASE_URL}/admin-geral/auth/login`, {
        celular,
        senha,
      });

      const data = response.data;

      // Salva o token e informações do usuário
      Cookies.set("authToken", data.token, { expires: 7 });
      Cookies.set("usuario", JSON.stringify({
        id: data.id,
        nome: data.nome,
        role: "AdministradorGeral",
        celular: data.celular,
        email: data.email
      }), { expires: 7 });

      // Redireciona para o painel do administrador geral
      navigate("/admin-geral/dashboard");

    } catch (err) {
      console.error(err);
      if (err.response && err.response.data && err.response.data.message) {
        setErro(err.response.data.message);
      } else {
        setErro("Celular ou senha inválidos.");
      }
    }
  };

  return (
    <div 
      style={{ 
        background: 'linear-gradient(to right, #898989, #192435ff)', 
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: '20px',
        paddingRight: '20px'
      }}
    >
      <Card className="shadow-lg" style={{ width: '100%', maxWidth: '380px', borderRadius: '15px' }}>
        <Card.Body className="p-4">
          <h3 className="text-center mb-4" style={{ color: '#898989' }}>
            Sistema MarcaAi 
          </h3>
          {erro && <Alert variant="danger">{erro}</Alert>}

          <Form onSubmit={handleLogin}>
            <Form.Group className="mb-3">
              <Form.Label>Celular</Form.Label>
              <Form.Control
                type="text"
                placeholder="Digite seu celular"
                value={celular}
                onChange={(e) => setCelular(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Senha</Form.Label>
              <Form.Control
                type="password"
                placeholder="Digite sua senha"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required
              />
            </Form.Group>

            <Button 
              variant="primary" 
              type="submit" 
              className="w-100"
              style={{ 
                background: 'linear-gradient(to right, 898989, #192435ff)', 
                border: 'none' 
              }}
            >
              Entrar
            </Button>

            <div className="text-center mt-3">
              <a href="/login" style={{ color: '#898989' }}>Voltar para login normal</a>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}

export default LoginAdminGeral;
